window.axios = require('axios');
window.fuse = require('fuse.js');
window.Vue = require('vue');

import Search from './components/Search.vue';
import hljs from 'highlight.js/lib/highlight';

// Syntax highlighting
hljs.registerLanguage('bash', require('highlight.js/lib/languages/bash'));
hljs.registerLanguage('css', require('highlight.js/lib/languages/css'));
hljs.registerLanguage('html', require('highlight.js/lib/languages/xml'));
hljs.registerLanguage('javascript', require('highlight.js/lib/languages/javascript'));
hljs.registerLanguage('json', require('highlight.js/lib/languages/json'));
hljs.registerLanguage('markdown', require('highlight.js/lib/languages/markdown'));
hljs.registerLanguage('php', require('highlight.js/lib/languages/php'));
hljs.registerLanguage('scss', require('highlight.js/lib/languages/scss'));
hljs.registerLanguage('yaml', require('highlight.js/lib/languages/yaml'));

document.querySelectorAll('pre code').forEach((block) => {
    hljs.highlightBlock(block);
});

Vue.config.productionTip = false;

new Vue({
    components: {
        Search
    },
}).$mount('#vue-search');

// pre analytics
// const ga = googleAnalytics({
//     trackingId: 'UA-37869872-17',
//     anonymizeIp: true
// });

// Check cookies
const value = getCookie('whga');
const seenBanner = getCookie('banner');

if(!seenBanner) {
    document.getElementById('cookie-law').classList.remove("hidden");
}

if(value !== "1") {
    // Analytics
    localStorage.removeItem("__anon_id");
    removeCookies();
}

function removeCookies() {
    let arrSplit = document.cookie.split(";");

    for(let i = 0; i < arrSplit.length; i++)
    {
        let cookie = arrSplit[i].trim();
        let cookieName = cookie.split("=")[0];

        // If the prefix of the cookie's name matches the one specified, remove it
        if(cookieName.indexOf("_ga") === 0 || cookieName.indexOf("_gi") === 0) {
            // Remove the cookie
            document.cookie = cookieName + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=.wh40k.it; path=/;";
        }
    }
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
